import TurndownService from "turndown";

function preprocessHTML(html) {
  // 保留段落开头的空格，转换为不间断空格
  html = html.replace(/<p>(\s+)/g, (match, spaces) => {
    const nbspSpaces = spaces.replace(/ /g, "&nbsp;");
    return "<p>" + nbspSpaces;
  });
  return html;
}

const turndownService = new TurndownService({
  headingStyle: "atx",
});

const originalTurndown = turndownService.turndown.bind(turndownService);

turndownService.turndown = (html) => {
  const processedHTML = preprocessHTML(html);
  return originalTurndown(processedHTML);
};

turndownService.addRule("strongThrough", {
  filter: ["strong"],
  replacement(content) {
    const lastStr = content[content.length - 1];
    const punctuationRegex =
      /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~！￥……（）——【】‘；：”“。，、？]$/;
    const isContain = punctuationRegex.test(lastStr);
    return isContain ? ` **${content}** ` : `**${content}**`;
  },
});
// 添加 video 标签保留规则
turndownService.addRule("video", {
  filter: ["video"],
  replacement(_content, node) {
    // 保留整个 video 标签的原始 HTML
    return (node as HTMLElement).outerHTML;
  },
});
// 定义扩展规则
// const openInNewTabRule = {
//   filter: 'a',
//   replacement(content, node) {
//     const href = node.getAttribute('href');
//     const target = node.getAttribute('target');
//     if (target === '_blank') {
//       return `[${content}](${href}){:target="_blank"}`;
//     }
//     return `[${content}](${href})`;
//   },
// };

// turndownService.addRule('openInNewTab', openInNewTabRule);

export default turndownService;
